import { createSelector } from '@reduxjs/toolkit';
import { linkRequestsAdapter } from 'features/user/state/user.slice';

// ---- LINK REQUESTS ----
export const { selectAll: baseLinkRequestsSelector } =
  linkRequestsAdapter.getSelectors(state => state.wnUser.linkRequests);

export const userSelector = state => state.wnUser.data;

export const userNutritionistSelector = state => state.wnUser.myNutritionist;

export const wnUserMedicalProfileSelector = createSelector(
  [userSelector],
  user => user.patientProfile.medicalProfile,
);

export const wnUserDietProfileSelector = createSelector(
  [userSelector],
  user => user.patientProfile.dietProfile,
);

export const userNutritionistOfficesSelector = createSelector(
  [userNutritionistSelector],
  nutritionist => {
    return (
      nutritionist?.offices
        .filter(office => office.status === 'active')
        .map(office => {
          const {
            street = '',
            neighborhood = '',
            state = '',
            zipCode = '',
          } = office.address || {};
          return {
            ...office,
            mode: office.mode,
            formattedAddress: `Calle: ${street}, colonia: ${neighborhood}, estado: ${state}, ${zipCode}`,
          };
        }) ?? []
    );
  },
);

export const userNutritionistServicesSelector = createSelector(
  [userNutritionistSelector, userNutritionistOfficesSelector],
  (nutritionist, offices) => {
    return (
      nutritionist?.nutritionistProfile.services.map(
        ({ service, ...restService }) => {
          return {
            ...restService,
            name: service.name,
            price: {
              value: restService.price,
              label: new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
              }).format(restService.price),
            },
            availableOffices: offices.filter(office =>
              restService.mode.includes(office.mode),
            ),
          };
        },
      ) ?? []
    );
  },
);

export const userLinkRequestsSelector = createSelector(
  [baseLinkRequestsSelector],
  linkRequests =>
    linkRequests.filter(linkRequest => linkRequest.starter === 'patient'),
);

export const nutritionistLinkRequestsSelector = createSelector(
  [baseLinkRequestsSelector],
  linkRequests =>
    linkRequests.filter(linkRequest => linkRequest.starter === 'nutritionist'),
);

export const wnUserTimeZoneSelector = (state) => state.wnUser.metadata.timeZone;
